import styled from '@emotion/styled'
import { breakpoints, spacing } from 'main/ui'

export const Container = styled.div`
  display: flex;

  @media (max-width: ${breakpoints.md}px) {
    flex-direction: column;
  }
`

export const DetailedPricingContainer = styled.div`
  flex: 3;
`

export const PricingFeedbackFormContainer = styled.div`
  flex: 2;
  margin: ${spacing.majorScale(3)}px 0 0 0;

  @media (min-width: ${breakpoints.md}px) {
    margin: 0 0 0 ${spacing.majorScale(5)}px;
  }
`
